export default "__VITE_ASSET__Bl2dn97k__"